import { IconButton, useOverlay } from '@fs/zion-ui'
import { ContentEdit } from '@fs/zion-icon'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import EditReservationDialog from './EditReservationDialog'
import { PermissionsContext } from '../../app/PermissionsContext'

export default function EditReservationButton({ reservation, onSuccess }) {
  const { isAuthorized } = useContext(PermissionsContext)
  const editReservationDialog = useOverlay()
  const { t } = useTranslation()

  return (
    isAuthorized('ModifyDataPermission') && (
      <>
        <IconButton
          Icon={ContentEdit}
          onClick={editReservationDialog.handleClick}
          description={t('reservations.edit', 'Edit Reservation')}
          size="xs"
        />
        <EditReservationDialog reservation={reservation} onSuccess={onSuccess} {...editReservationDialog} />
      </>
    )
  )
}
